import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type TExperiments } from '@/app/shared/types/experiments';

const initialState = {} as TExperiments;

export const { reducer: experimentsReducer, actions: experimentsActions } = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    setExperiments: (_state, action: PayloadAction<TExperiments>) => action.payload,
  },
});
